import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@aimsos/i18n';
import { useWorkQueueContext } from '../../../context/useWorkQueueContext.js';
import { WORK_QUEUE_PATHS } from '../../../constants/inboxViews.js';
import { ArrowUpRight } from 'lucide-react';

/** Linked proposal that triggered this review request. */
function LinkedProposalBlock({ linkedProposal }) {
  const { t } = useTranslation('work-queues-app');
  const navigate = useNavigate();
  const { clearFilters } = useWorkQueueContext();
  if (!linkedProposal) return null;

  const handleOpen = () => {
    clearFilters();
    navigate(WORK_QUEUE_PATHS.event(linkedProposal.id));
  };

  return (
    <div>
      <p className="text-xs font-semibold uppercase tracking-wide text-content-faint">
        {t('govReview.linkedProposal')}
      </p>
      <button
        type="button"
        onClick={handleOpen}
        className="mt-2 flex w-full items-center justify-between gap-3 rounded-lg border border-edge px-4 py-3 text-left transition-colors hover:bg-surface-hover"
      >
        <span className="min-w-0">
          <span className="font-mono text-xs text-content-faint">
            {linkedProposal.spec ?? linkedProposal.id}
          </span>
          <span className="mt-0.5 block truncate text-sm font-medium text-content">
            {linkedProposal.title}
          </span>
        </span>
        <ArrowUpRight size={16} className="flex-shrink-0 text-content-muted" />
      </button>
    </div>
  );
}

export default LinkedProposalBlock;
